import { type ReactNode } from 'react'
import { cn } from '../../lib/utils'
import { Skeleton } from '../ui/skeleton'

interface Props {
  /** The avatar, on the left of the identity row */
  avatar: ReactNode
  /** Identity beside the avatar: name, stats */
  children: ReactNode
  /** Full-width row of buttons under the identity row */
  actions?: ReactNode
  /** When true, renders a skeleton avatar */
  loading?: boolean
  className?: string
}

/**
 * The compact header at the top of profile pages: avatar beside name + stats,
 * with the profile's buttons in one row underneath.
 */
export function ProfileHero({ avatar, children, actions, loading, className }: Props) {
  return (
    <section className={cn('space-y-4', className)}>
      <div className="flex items-center gap-4">
        <div className="relative shrink-0">
          {loading ? <Skeleton className="size-24 rounded-full" /> : avatar}
        </div>
        <div className="flex min-w-0 flex-1 flex-col items-start">{children}</div>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </section>
  )
}
